"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var enhancers_1 = require("./enhancers");

var enhance_props_1 = __importDefault(require("./enhance-props"));

var safeHref_1 = require("./utils/safeHref");

var Box = function Box(_a) {
  var _a$is = _a.is,
      is = _a$is === void 0 ? 'div' : _a$is,
      innerRef = _a.innerRef,
      children = _a.children,
      allowUnsafeHref = _a.allowUnsafeHref,
      props = __rest(_a, ["is", "innerRef", "children", "allowUnsafeHref"]); // Convert the CSS props to class names (and inject the styles)


  var _enhance_props_1$defa = enhance_props_1.default(props),
      className = _enhance_props_1$defa.className,
      parsedProps = _enhance_props_1$defa.enhancedProps;

  parsedProps.className = className;

  if (innerRef) {
    parsedProps.ref = innerRef;
  }
  /**
   * If the user has enabled safe hrefs we want to make sure that the url passed
   * uses a safe protocol and that the other attributes that make the link safe are
   * added to the element
   */


  var safeHrefEnabled = (typeof allowUnsafeHref === 'boolean' ? !allowUnsafeHref : safeHref_1.getUseSafeHref()) && is === 'a' && parsedProps.href;

  if (safeHrefEnabled) {
    var _safeHref_1$extractAn = safeHref_1.extractAnchorProps(parsedProps.href, parsedProps.rel),
        safeHref = _safeHref_1$extractAn.safeHref,
        safeRel = _safeHref_1$extractAn.safeRel;

    parsedProps.href = safeHref;
    parsedProps.rel = safeRel;
  }

  return react_1.default.createElement(is, parsedProps, children);
};

Box.displayName = 'Box';
Box.propTypes = Object.assign({}, enhancers_1.propTypes, {
  innerRef: prop_types_1.default.oneOfType([prop_types_1.default.func, prop_types_1.default.shape({
    current: prop_types_1.default.element
  })]),
  is: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.func, prop_types_1.default.elementType])
});
Box.defaultProps = {
  innerRef: null,
  is: 'div',
  boxSizing: 'border-box'
};
exports.default = Box;